import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppButton } from "./WhatsAppButton";
import { useI18n } from "../i18n";
import * as apiClient from "../api";

export const Layout = ({ children, noPadding = false }) => {
  const { t } = useI18n();
  const { data: settings } = useQuery({ queryKey: ["publicSettings"], queryFn: apiClient.getPublicSettings });
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className={`flex-1 ${noPadding ? "" : "pt-16"}`}>{children}</main>
      <Footer />
      <WhatsAppButton label={t("whatsapp.help")} phone={settings?.whatsapp} />
    </div>
  );
};
